module.exports = __webpack_public_path__ + "static/media/share.5fd055d1.png";